import React, { memo, useMemo } from "react";
import StudentPersonalDetailsLayout from "../StudentPersonalDetailsLayout";
import { useTranslation } from "react-i18next";
import { getStudentPersonalDetailsFields } from "../../module/utils";
import _ from "lodash";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import classes from "./StudentPersonalDetailsSkeleton.scss";

const StudentPersonalDetailsSkeleton = () => {
  const { t } = useTranslation();
  const fields = useMemo(() => getStudentPersonalDetailsFields({ t }), [t]);
  return (
    <StudentPersonalDetailsLayout isLoading>
      {_.map(fields, ({ fieldUid, label, span }) => {
        return (
          <div
            style={{
              gridColumn: `span ${span || 1}`,
            }}
            key={fieldUid}
            className={classes.field}
          >
            <div className="text-label">{label}</div>
            <SkeletonLoader height="36px" width="100%" />
          </div>
        );
      })}
    </StudentPersonalDetailsLayout>
  );
};

export default memo(StudentPersonalDetailsSkeleton);
